import { render } from "./location-edit.vue?vue&type=template&id=09c24482&scoped=true"
import script from "./location-edit.vue?vue&type=script&lang=js"
export * from "./location-edit.vue?vue&type=script&lang=js"

import "./location-edit.vue?vue&type=style&index=0&id=09c24482&scoped=true&lang=less"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c24482"]])

export default __exports__